import { useMemo } from 'react';
import { AnalysisPurposeEnum } from '@vivli/features/data-requests/infrastructure/enum';

const ANALYSIS_PURPOSE_TEXT_MAP: Record<AnalysisPurposeEnum, string> = {
    [AnalysisPurposeEnum.NewResearchTreatmentEffectiveness]:
        'New research question to examine treatment effectiveness on secondary endpoints and/or within subgroup populations',
    [AnalysisPurposeEnum.NewResearchTreatmentSafety]: 'New research question to examine treatment safety',
    [AnalysisPurposeEnum.ConfirmingResearchTreatmentEffectiveness]:
        'Research that confirms or validates previously conducted research on treatment effectiveness',
    [AnalysisPurposeEnum.ConfirmingResearchTreatmentSafety]:
        'Research that confirms or validates previously conducted research on treatment safety',
    [AnalysisPurposeEnum.PreliminaryResearch]: 'Preliminary research to be used as part of a grant proposal',
    [AnalysisPurposeEnum.SummaryLevelDataMetaAnalysis]: 'Summary-level data meta-analysis',
    [AnalysisPurposeEnum.ParticipantLevelDataMetanalysis]: 'Participant-level data meta-analysis',
    [AnalysisPurposeEnum.SupportClinicalTrialDesign]: 'Support clinical trial design',
    [AnalysisPurposeEnum.StatisticalMethods]: 'Statistical methods',
    [AnalysisPurposeEnum.TrainingTesting]: 'Training/Testing',
    [AnalysisPurposeEnum.Other]: 'Other',
};

export function useAnalysisPurposeTextMap() {
    const mapText = useMemo(
        () => (purpose: AnalysisPurposeEnum) => {
            return ANALYSIS_PURPOSE_TEXT_MAP[purpose] || purpose;
        },
        []
    );

    return mapText;
}
